import { TdsAlert, TdsButton, TdsButtonContainer, TdsField } from '@trv-tds/react';
import { GlobalContext } from 'context/GlobalProvider';
import _every from 'lodash/every';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import _values from 'lodash/values';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { validatePin } from '../../apis/pa-services';
import { EPHR_LOGIN_URL, RESPONSES } from '../../utils/constants';
import { metricsElementTag, metricsPage, metricsPageViewTag } from '../../utils/coremetrics';
import { getRequiredAlertText } from '../../utils/validation';
import './styles.scss';
import ScrollToTop from '../../components/shared/ScrollToTop';
import Content from '../../components/shared/Content';

const ERROR_404 = RESPONSES.ERROR_404.error;

export default function Begin() {
    const [tempId, setTempId] = useState('');
    const [tempPin, setTempPin] = useState('');
    const [alerts, setAlerts] = useState({ tempId: '', tempPin: '' });
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [agreeClicked, setAgreeClicked] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    useEffect(() => {
        setPageLoading(true);
        setTimeout(() => {
            setPageLoading(false);
        }, 1500);
    }, []);
    const navigate = useNavigate();
    const {
        actions: { updateAcctInfo, throwError }
    } = useContext(GlobalContext);

    const agreeClick = async () => {
        metricsElementTag(metricsPage.begin, false);
        setBusy(true);
        setAgreeClicked(true);
        if (formValid()) {
            const { data, errors } = await validatePin(tempId, tempPin);
            if (data) {
                const {
                    temporaryCredential: { accountNbr, delegateId },
                    policyTerms
                } = data;
                updateAcctInfo({ accountNbr, delegateId, policyTerms, tempPin });
                navigate('/policies');
            } else if (_some(errors, ({ code }) => code === '8001')) {
                const { message } = _find(errors, ({ code }) => code === '8001');
                setError(message);
                setBusy(false);
                focusSitewideAlert();
                window.scrollTo(0, 0);
            } else throwError('404', ERROR_404);
        } else {
            setBusy(false);
        }
    };

    useEffect(() => {
        metricsPageViewTag(metricsPage.begin);
    }, []);

    useEffect(() => {
        setAlerts({ tempPin: getRequiredAlertText(tempPin), tempId: getRequiredAlertText(tempId) });
    }, [tempId, tempPin]);

    const formValid = () => {
        return _every(_values(alerts), alertText => _isEmpty(alertText));
    };

    const existingUserClick = () => {
        window.location.href = EPHR_LOGIN_URL;
    };

    const focusSitewideAlert = () => {
        document.getElementById('errorAlertMsg').focus();
    };

    return (
        <>
            <Content loading={pageLoading}>
                <ScrollToTop />
                <div className="begin">
                    <h1 className="tds-h1--article center reg-header" data-testid="pa-reg-header">
                        Premium Audit Registration
                    </h1>
                    <form>
                        <div className="tds-d-flex tds-flex-column tds-align-items-center">
                            <div className="login-container">
                                <p>
                                    To begin the Premium Audit registration process, enter the
                                    Temporary User ID and PIN provided on your invitation letter.
                                </p>
                                <TdsAlert
                                    data-testid="errorAlert"
                                    className={error ? '' : 'tds-d-none'}
                                    type="error"
                                    id="errorAlertMsg"
                                >
                                    <div className={'alert-desc'}>{error}</div>
                                </TdsAlert>
                                <TdsField
                                    label="TEMPORARY USER ID"
                                    alert={agreeClicked && alerts.tempId ? 'error' : ''}
                                    message={agreeClicked ? alerts.tempId : ''}
                                    data-testid="tempUserId"
                                    slot="label"
                                >
                                    <input
                                        type="text"
                                        id="tempUserId"
                                        name="tempUserId"
                                        placeholder="Enter your Temporary Id"
                                        aria-required="true"
                                        onChange={e => setTempId(e.target.value)}
                                        autoComplete="off"
                                    />
                                </TdsField>
                                <TdsField
                                    label="PIN"
                                    alert={agreeClicked && alerts.tempPin ? 'error' : ''}
                                    message={agreeClicked ? alerts.tempPin : ''}
                                    data-testid="tempPin"
                                >
                                    <input
                                        type="text"
                                        id="tempPin"
                                        name="pin"
                                        className="tlPrivate"
                                        placeholder="Enter your PIN"
                                        aria-required="true"
                                        onChange={e => setTempPin(e.target.value)}
                                        autoComplete="off"
                                    />
                                </TdsField>
                            </div>
                            <p className="tds-small pa-terms">
                                By selecting Agree & Continue below, you certify that you are a
                                Travelers business insurance policyholder or authorized
                                representative and you have read and agree to the&nbsp;
                                <Link
                                    id="aBeginRegistrationTermsConditions"
                                    target="_blank"
                                    to="/terms-conditions"
                                    aria-label="ePHR Terms of Service"
                                >
                                    <span className={'links'}>Terms of Service</span>
                                </Link>
                                .
                            </p>
                            <TdsButtonContainer class="button-container-fix">
                                <TdsButton
                                    id="agreeContinueBtn"
                                    variant="primary"
                                    busy={busy}
                                    disabled={busy}
                                    onClick={agreeClick}
                                >
                                    Agree & Continue
                                </TdsButton>
                                <TdsButton
                                    id="existingUserBtn"
                                    variant="tertiary"
                                    busy={busy}
                                    onClick={existingUserClick}
                                >
                                    <span className={'links'}>Already Registered? Login Here</span>
                                </TdsButton>
                            </TdsButtonContainer>
                        </div>
                    </form>
                </div>
            </Content>
        </>
    );
}
